import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { TextFieldProps } from '@/components/form/TextField/TextField';
import FeedbackError from '@/components/form/FeedbackError/FeedbackError';
import { FieldGroup, InputElement } from './InputTel.styles';
import Label from '@/components/form/Label/Label';

// @ts-ignore
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
// @ts-ignore
import intlTelInputUtils from 'intl-tel-input/build/js/utils';
import localizedCountries from '@/components/form/InputTel/localizedCountries';
import { VALIDATION_MESSAGES } from '@/features/forms/validation';

export interface InputTelProps extends TextFieldProps {
  label?: string;
  required?: boolean;
  setValue?: (name: string, value: unknown, config?: Object) => void;
  setError?: (name: string, value: unknown, config?: Object) => void;
}

const InputTel = React.forwardRef<HTMLInputElement, InputTelProps>(
  ({ label, setValue, setError, name, required, placeholder, error, className, ...props }: InputTelProps, ref) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    const getInstance = () => {
      let input = inputRef.current;
      // @ts-ignore
      return window.intlTelInputGlobals.getInstance(input);
    };

    const proxyPhoneData = () => {
      if (typeof setValue === 'function') {
        const { name: countryName, iso2, dialCode } = getInstance().selectedCountryData;
        setValue(`${name}Data`, {
          number: getInstance().getNumber(),
          countryName,
          iso2,
          dialCode,
        });
      }
    };

    useEffect(() => {
      let iti: typeof intlTelInput = null;

      if (inputRef.current) {
        iti = intlTelInput(inputRef.current, {
          autoPlaceholder: 'aggressive',
          initialCountry: 'BR',
          autoHideDialCode: false,
          utilsScript: intlTelInputUtils,

          separateDialCode: true,
          // formatOnDisplay: false,
          nationalMode: true,
          preferredCountries: ['BR', 'AU', 'NZ', 'US'],
          localizedCountries,
        });
      }
      // unmount
      return () => {
        iti?.destroy();
      };
    }, [inputRef]);

    return (
      <FieldGroup>
        {label && (
          <Label htmlFor={name} required={required}>
            {label}
          </Label>
        )}
        <InputElement
          ref={(ref) => {
            inputRef.current = ref;
          }}
          type="tel"
          name={`${name}`}
          placeholder={placeholder}
          className={cx(
            {
              'is-invalid': error,
            },
            className
          )}
          {...props}
          onChange={async (e) => {
            // if (typeof setValue === 'function') {
            //   setValue(name, getInstance().getNumber());
            // }
            if (typeof props.onChange === 'function') {
              props.onChange(e);
              proxyPhoneData();
            }
          }}
          onBlur={async (e) => {
            proxyPhoneData();
          }}
        />
        <FeedbackError error={error === 'Required' ? VALIDATION_MESSAGES.required : error} />
      </FieldGroup>
    );
  }
);

InputTel.displayName = 'InputTel';

export default InputTel;
